/* 用户中心数据 */
const center = {
  reserve: false, // 对话框显示状态
  toast: false, // 提示
};
export default center;